<template>
    <apexo-modal
        :name="name"
        size="sm"
        :title="$t('orders.activations.licenseKeyModal.title')"
        ref="modal"
        @closed="onClosed"
        @open="onOpen"
        @opened="onOpened"
    >
        <section class="space-y-4">
            <apexo-textarea disabled v-model="licenseKey" />

            <div class="bg-blue-100 border border-blue-200 p-4 text-sm text-blue-600 rounded-sm">
                {{ $t('orders.activations.licenseKeyModal.copiedToClipboard') }}
            </div>
        </section>

        <template #footer>
            <apexo-button ref="closeButton" @click="close">
                {{ $t('orders.activations.licenseKeyModal.button') }}
            </apexo-button>
        </template>
    </apexo-modal>
</template>

<script>
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoModal from '@/components/Elements/ApexoModal';

    export default {
        components: {
            ApexoButton,
            ApexoModal,
        },

        props: {
            name: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                licenseKey: '',
            };
        },

        methods: {
            onOpen({ licenseKey } = {}) {
                this.licenseKey = licenseKey;
            },

            async onOpened() {
                this.$refs.closeButton.focus();

                await navigator.clipboard.writeText(this.licenseKey);
            },

            onClosed() {
                this.$emit('closed');
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
